module.exports = __webpack_public_path__ + "media/images/screens/05_pageType-a51d079c4607cfe99f2653f7b1c92200.jpg";